import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import Chevron from "core/icons/chevron/chevron-right.svg";
import { GetMarginStyle, GetPaddingStyle } from "core/styles/paddingMarginStyle";
import { Container, BreadcrumbItem, BreadcrumbList } from "./_breadcrumbStyle";

// @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
const BreadcrumbContext = React.createContext();

export type ItemProps = {
  children?: React.ReactNode;
  active?: boolean;
  href: string | { pathname: string; search?: string; state?: any };
  "data-testid"?: string;
  itemWidth?: string;
} & GetMarginStyle &
  GetPaddingStyle;

function Item(props: ItemProps) {
  const { children, href, active, "data-testid": dataTestId, ...rest } = props;

  const history = useHistory();
  const { itemWidth } = useContext(BreadcrumbContext);

  const breadcrumbClickHandler = (e: any) => {
    e.preventDefault();

    if (active) return;

    history.push(href);
  };

  return (
    // @ts-expect-error TS(2769): No overload matches this call.
    <BreadcrumbItem className="breadcrumb-item" active={active} itemWidth={itemWidth} {...rest}>
      <a data-testid={dataTestId} onClick={breadcrumbClickHandler}>
        {children}
      </a>
    </BreadcrumbItem>
  );
}

export type BreadcrumbProps = {
  children?: React.ReactNode;
  icon?: string;
  itemWidth?: string;
} & GetMarginStyle &
  GetPaddingStyle;

function Breadcrumb(props: BreadcrumbProps) {
  const { children, itemWidth, ...rest } = props;

  return (
    <BreadcrumbContext.Provider value={{ itemWidth }}>
      <Container aria-label="breadcrumb" className="breadcrumb-container" {...rest}>
        <BreadcrumbList className="breadcrumb-list">{children}</BreadcrumbList>
      </Container>
    </BreadcrumbContext.Provider>
  );
}

Breadcrumb.Item = Item;

Item.defaultProps = {
  active: false,
  href: "",
};

Breadcrumb.defaultProps = {
  icon: Chevron,
  itemWidth: "240px",
};

export default Breadcrumb;
